import React from "react";
import FadeAlert from "./fade-alert";

const LanguageSwitcher = ({ lang, setLang, style }) => {
    const options = [
        { code: "en", label: "EN" },
        { code: "ru", label: "RU" },
        { code: "ua", label: "UA" },
    ];
    return (
        <div className="d-flex gap-2" style={{ marginBottom: "25px", ...style }}>
            {options.map((o) => (
                <button
                    key={o.code}
                    type="button"
                    className={`btn btn-sm ${lang === o.code ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => {
                        setLang(o.code);
                        window.dispatchEvent(
                            new CustomEvent("app:languageChanged", {
                                detail: { lang: o.code },
                            })
                        );
                    }}
                    aria-pressed={lang === o.code}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
};

export default LanguageSwitcher;
